import type { Media } from "@shared/graphql.types";
import { useMediaQueries } from "@shared/ui.hooks";
import type { Dispatch, SetStateAction } from "react";
import type { Swiper as SwiperType } from "swiper";
import { Swiper } from "swiper/react";

import { GalleryImageSlide } from "../GalleryImageSlide/GalleryImageSlide";
import { GalleryVideoSlide } from "../GalleryVideoSlide/GalleryVideoSlide";
import { isVideoType } from "../utils/utils";

import * as styles from "./GalleryThumbnails.css";

type GalleryThumbnailProps = {
  media: Media[];
  setThumbsSwiper: Dispatch<SetStateAction<SwiperType | null>>;
  useCloudinary: boolean;
  initialIndex: number;
  handleThumbnailClick?: (id: string, type: string) => void;
};
export const GalleryThumbnails: React.FC<GalleryThumbnailProps> = ({
  media,
  useCloudinary,
  setThumbsSwiper,
  initialIndex,
  handleThumbnailClick
}) => {
  const { isMd } = useMediaQueries();

  const thumbsSize = isMd ? 80 : 84;

  return (
    <div id="GalleryThumbnails" className={styles.galleryThumbnails}>
      <div className={styles.thumbsSwiperStyles}>
        <Swiper
          onInit={(swiper) => {
            if (
              typeof swiper.params.navigation !== "boolean" &&
              swiper.params.navigation
            ) {
              const { navigation } = swiper.params;
              navigation.prevEl = ".new-swiper-button-prev";
              navigation.nextEl = ".new-swiper-button-next";
            }
            swiper.navigation.update();
          }}
          freeMode
          watchSlidesProgress
          slideToClickedSlide
          onSwiper={setThumbsSwiper}
          slidesPerView={"auto"}
          initialSlide={initialIndex}
          direction={"horizontal"}
          spaceBetween={8}
          noSwipingClass="vjs-control-bar"
          className={styles.mobileGalleryThumbnails}
        >
          {media?.map((item, index) => {
            if (isVideoType(item)) {
              return (
                <GalleryVideoSlide
                  key={`thumbnails-video-${index}`}
                  item={item}
                  index={index}
                  thumbsSize={thumbsSize}
                  isThumbnail={true}
                  onClick={() => handleThumbnailClick?.(item.id, "video")}
                />
              );
            }
            return (
              <GalleryImageSlide
                key={`thumbnails-image-${index}`}
                thumbsSize={thumbsSize}
                item={item}
                index={index}
                useCloudinary={useCloudinary}
                onClick={() => handleThumbnailClick?.(item.src, "image")}
              />
            );
          })}
          {/* This will be readded at a later date */}
          {/* <button
            id="button-test-2"
            onClick={() => {
              trackProductImageViewed()
            }}
            className={`new-swiper-button-next ${thumbsNavButton}`}
          >
            <ChevronRightIcon
              fill={colours.secondary.light}
              className={bottomDesktopIcon}
            />
          </button> */}
        </Swiper>
      </div>
    </div>
  );
};
